import { Injectable } from '@angular/core';
import { HttpService } from '../providers/http.service';
import { AppConfig } from '../app/app.config'; 
import { PageDefault } from '../pages/PageDefault';



@Injectable()
export class NormalReportService {
    constructor(
        private httpService: HttpService,
        private config:AppConfig) { 

        }

    // now = new Date();
    // tomorrow = new Date(this.now.getDate() + 1);
    username=this.config.getCurrentUser().UserName;

    //获取常规投注信息
    //TQQ 2016-12-29
    getNormalReport(input:NormalReportInput) {
        let param = "startDate=" + input.StartDate + "&endDate=" + input.EndDate + "&pageSize=" + input.PageSize + "&pageIndex=" + input.PageIndex + "&userName=" + this.username 
        + "&issue=" + input.IssueNo + "&lotteryCode=" + input.LotteryCode + "&state=" + input.State
        + "&orderType=" + input.OrderType + "&bettingType=" + input.bettingType;
        let url = AppConfig.GetProdUrl() + "/Report/comm?" + param;
        return this.httpService.get(url);
    }

    //获取团队游戏记录
    //chen 2017-08-14
       getTeamNormalReport(input:TeamNormalReportInput) {
        let param = "end=" + input.end + "&lotterycode=" + input.lotteryCode+ "&ordertype=" + input.orderType+  "&pageIndex=" + input.pageIndex +"&pageSize=" + input.pageSize +"&start=" + input.start +  "&userName=" + input.userName
        + "&playModeType=" + input.playModeType
        ;
        let url = AppConfig.GetProdUrl() + "/Team/GetTeamCommBettings?" + param;
        return this.httpService.get(url);
    }

    //获取所有彩种
    //TQQ 2017-01-02
    getAllLotterys() {
        let url = AppConfig.GetProdUrl() + "/Report/Lottery";
        return this.httpService.get(url);
    }

    //获取订单详情
    //TQQ 2017-01-02
    getOrderDetail(bettingId: number, type: number = 0) {
        let param = "bettingId=" + bettingId;
        let url = type == 0
            ? AppConfig.GetProdUrl() + "/Report/GetOrderDetail"
            : AppConfig.GetProdUrl() + "/Lottery/QueryKQBettingModel";
        return this.httpService.get(url + "?" + param);
    }

    //撤单
    //TQQ 2017-02-22
    revocationCommand(modeType: number, bettingId: number) {
        let param = modeType == 0 ? "bettingId=" + bettingId : "btIssueId=" + bettingId;
        let url = modeType == 0
            ? AppConfig.GetProdUrl() + "/Lottery/RevocationCommand"
            : AppConfig.GetProdUrl() + "/Lottery/KQWFRevocateIssue";
        return this.httpService.get(url + "?" + param);
    }

    //全部撤单
    //TQQ 2017-02-23
    allrevocationCommand(modeType: number, bettingId: number) {
        let param = "bettingId=" + bettingId;
        let url = modeType == 0
            ? AppConfig.GetProdUrl() + "/Lottery/AllRevocationCommand"
            : AppConfig.GetProdUrl() + "/Lottery/KQWFRevocateOrder";
        return this.httpService.get(url + "?" + param);
    }


}


export class NormalReportInput {
    IssueNo: string = "";
    State: string = "";
    UserName: string = "";
    LotteryCode: string = "_ALL";
    OrderType: string = "01";
    StartDate: string = PageDefault.endNowDate();
    EndDate: string = PageDefault.endDate();
    PageIndex: number = 1;
    PageSize: number = PageDefault.PageSize();
    bettingType: string = "_ALL";
}

export class TeamNormalReportInput {
    userName: string = "";
    lotteryCode: string = "_ALL";
    orderType: string = "01";
    start: string = PageDefault.endNowDate();
    end: string = PageDefault.endDate();
    pageIndex: number = 1;
    pageSize: number = PageDefault.PageSize();
    playModeType: string = "_ALL";
}



// WEBPACK FOOTER //
// ./src/services/normalreport.service.ts